module.exports = __webpack_public_path__ + "img/ship-left.fd7183f4.png";